import React, {useState} from 'react';
import {Button, Modal, ModalActions, ModalContent, ModalTitle} from "@deere/fuel-react";
import {generateDisplayName} from "../utils";
import {Block, CheckCircle} from "@material-ui/icons";

export const FeedbackWindowModal = ({feedbackOpen, remainingUsers, onSave}) => {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirm = () => {
        onSave();
    }

    return (
        <div>
            <Button variant="text" onClick={handleClickOpen} startIcon={feedbackOpen ? <Block /> : <CheckCircle />}>
                {feedbackOpen ? "Close Feedback" : "Open Feedback"}
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth={true}
            >
                <ModalTitle onClose={handleClose}>
                    {feedbackOpen ? "Close Feedback Window" : "Open Feedback Window"}
                </ModalTitle>
                <ModalContent>
                    {feedbackOpen && <p>
                        Are you sure you want to close the feedback window?
                        Stakeholders will be unable to provide their feedback until the feedback window is re-opened.
                    </p>}
                    {!feedbackOpen && <p>
                        Are you sure you want to re-open the feedback window?
                    </p>}
                    {!!remainingUsers?.length && (
                        <>
                            <span>The following people haven't submitted their feedback yet:</span>
                            <ul>
                            {remainingUsers.map(user => (
                                <li key={`pnd-stakes-${user.racfID}`}>{generateDisplayName(user.firstName, user.lastName, user.racfID)}</li>
                            ))}
                            </ul>
                        </>
                    )}
                </ModalContent>
                <ModalActions>
                    <Button variant={"secondary"} onClick={handleClose}>Cancel</Button>
                    <Button variant={"primary"} onClick={handleConfirm}>Confirm</Button>
                </ModalActions>
            </Modal>
        </div>
    );
};
